import { router } from '@inertiajs/react';
import i18n from 'i18next';
import { toast } from '../components/Toast/toastStore';

/** Evenement global d'Inertia (`invalid` / `exception`) tel qu'on l'exploite ici. */
interface InertiaErrorEvent {
    preventDefault: () => void;
    detail?: {
        response?: { status?: number };
        exception?: unknown;
    };
}

/**
 * Par defaut, Inertia affiche dans une grande modale (~80 % de la page) toute reponse qui n'est pas
 * une reponse Inertia : page d'erreur HTML du serveur, redirection vers la connexion apres
 * expiration de la session / du jeton CSRF, etc. Illisible pour un utilisateur : on la remplace par
 * un message court, traduit, dans une notification.
 */
export const messageKeyForStatus = (status?: number): string => {
    if (status === 401 || status === 419) {
        return 'session_expired_reload';
    }
    if (status === 403) {
        return 'access_denied';
    }
    if (status === 404) {
        return 'page_not_found';
    }
    if (status !== undefined && status >= 500) {
        return 'server_error_retry';
    }

    return 'unexpected_error';
};

/** Branche les handlers globaux ; retourne la fonction qui les retire. */
export const registerInertiaErrorHandlers = (): (() => void) => {
    const removeInvalid = router.on('invalid', (event: InertiaErrorEvent) => {
        event.preventDefault();
        // eslint-disable-next-line no-console
        console.error('[Inertia] reponse non-Inertia', event.detail?.response?.status);
        toast.error(i18n.t(messageKeyForStatus(event.detail?.response?.status)));
    });

    const removeException = router.on('exception', (event: InertiaErrorEvent) => {
        event.preventDefault();
        // eslint-disable-next-line no-console
        console.error('[Inertia] exception', event.detail?.exception);
        toast.error(i18n.t('network_error'));
    });

    return () => {
        removeInvalid();
        removeException();
    };
};
